import i18n from 'i18next'
import { initReactI18next } from "react-i18next"
import id from './id.json'
import bd from './bd.json'
import br from './br.json'
import kr from './kr.json'

const resources = {
    id: {
        translation: id
    },
    bd: {
        translation: bd
    },
    bn: {
        translation: bd
    },
    br: {
        translation: br
    },
    kr: {
        translation: kr
    }
}



i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "id",
        interpolation: {
        escapeValue: false
        }
    });

export default i18n